import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorKyc = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M9.75 9.15a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm4.732 2.812a3.75 3.75 0 1 0-4.963 0A5.75 5.75 0 0 0 6.25 17.15a.75.75 0 0 0 1.5 0 4.25 4.25 0 0 1 8.5 0 .75.75 0 0 0 1.5 0 5.75 5.75 0 0 0-3.268-5.188Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M5 21.321a2.75 2.75 0 0 1-2.75-2.75V5A2.75 2.75 0 0 1 5 2.25h14A2.75 2.75 0 0 1 21.75 5v13.571a2.75 2.75 0 0 1-2.75 2.75h-4.154l-1.515 1.775a1.75 1.75 0 0 1-2.662 0l-1.515-1.775H5Zm-1.25-2.75c0 .69.56 1.25 1.25 1.25h4.5a.75.75 0 0 1 .57.263l1.74 2.038c.1.117.28.117.38 0l1.74-2.038a.75.75 0 0 1 .57-.263H19c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v13.571Z"
    />
  </svg>
);
export default SvgTwoColorKyc;
